import * as React from "react";
import {
  OverviewTitle,
  OverviewTitleWrapper,
} from "../../../components/Details/OverviewInfo/styles";
import {
  DetailInnerWrapper,
  DetailPageBox,
} from "../../../components/sharedStyles";
import ServiceContractTable from "src/components/Tables/ServiceContracts/FullTable";

import useActiveFilters from "../../../hooks/useActiveFilters";
import { useFilteredIndustrialPremises } from "src/store/industrialPremises";

export const PERSISTANT_CATEGORY_KEY = "persistant_category_servicecontrat";

export default function ServiceContracts() {
  const { filteredRealEstates } = useActiveFilters();

  const persistantQuery = {
    realestate_ids: filteredRealEstates,
    draft: false,
  };

  return (
    <>
      <DetailInnerWrapper>
        <DetailPageBox>
          <OverviewTitleWrapper>
            <OverviewTitle>Översikt</OverviewTitle>
          </OverviewTitleWrapper>

          <ServiceContractTable persistantQuery={persistantQuery} />
        </DetailPageBox>
      </DetailInnerWrapper>
    </>
  );
}
